export const VOLUME_PRICING_MODAL_ID = 'volume-pricing-modal'
export const VOLUME_PRICING_MODAL_CONTAINER_ID =
  'volume-pricing-modal-container'
